import XLSX from 'xlsx';

const formatData = (dataSet, pastTopLevel = false) => {
  let formatted = dataSet;
  
  if (Array.isArray(dataSet)) {
    formatted = dataSet.map(item => {
      if (typeof item === 'string') {
        if (item && item.includes(',')) return `"${item}"`
        else return item
      }
      else if (Array.isArray(item) || typeof item === 'object') return formatData(item)
      else return item;
    })
  } else if (typeof dataSet === 'object') {
    let childValue = pastTopLevel ? [] : null;
    formatted = Object.keys(dataSet)[pastTopLevel ? 'forEach' : 'map']((key, i) => {
      let formattedValue;
      const value = dataSet[key];
      if (typeof value === 'string') formattedValue =  `${key}: ${value}`
      else if (typeof value === 'object' || Array.isArray(value)) formattedValue = `${key}: ${formatData(value, true)}`
      else formattedValue =  value;
      if (pastTopLevel) {
        childValue.push(formattedValue);
      } else if (!pastTopLevel) {
        return formattedValue;
      }
    })
    if (childValue) formatted = childValue.join(' - ')
  }
  return Array.isArray(formatted) ? formatted.join(' | ') : formatted;
}


const handleDownload = (filename, type, controller) => {
  const headers = controller.headers.filter(headerSettings => headerSettings.id !== 'dt_group_checkbox');
  const data = Object.values(controller.master);
  let file = [];
  let filteredData = data.map(dataObj => {
    let retData = [];
    headers.forEach(headerObj => {
      let dataSet = dataObj[headerObj.key];
      if (typeof dataSet !== 'string') dataSet = formatData(dataSet);
      if (dataSet && typeof dataSet == 'string' && dataSet.includes(",")) dataSet = `"${dataSet}"`
      retData.push(dataSet)
    })
    return retData;
  })
  file.push(headers.map(headerObj => headerObj.title));
  file.push(...filteredData);
  if(type[0] === 'csv') {
    let csvContent = 'data:text/csv;charset=utf-8,'
      + file.map(e => e.join(',')).join('\n');
    const encoded = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encoded);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else if (type[0] === 'xlsx' || type[0] === 'xls') {
    const ws = XLSX.utils.aoa_to_sheet(file);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, filename);
  } else {
    console.log(`${type} type is not supported.`)
  }
}

export default handleDownload;
